/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteDirectoryRoleMappingSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteDirectoryRoleMappingRequest = {
  /**
   * The ID of the mapping to remove.
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteDirectoryRoleMappingSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteDirectoryRoleMappingSecurity$outboundSchema: z.ZodMiniType<
  DeleteDirectoryRoleMappingSecurity$Outbound,
  DeleteDirectoryRoleMappingSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteDirectoryRoleMappingSecurityToJSON(
  deleteDirectoryRoleMappingSecurity: DeleteDirectoryRoleMappingSecurity,
): string {
  return JSON.stringify(
    DeleteDirectoryRoleMappingSecurity$outboundSchema.parse(
      deleteDirectoryRoleMappingSecurity,
    ),
  );
}

/** @internal */
export type DeleteDirectoryRoleMappingRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteDirectoryRoleMappingRequest$outboundSchema: z.ZodMiniType<
  DeleteDirectoryRoleMappingRequest$Outbound,
  DeleteDirectoryRoleMappingRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteDirectoryRoleMappingRequestToJSON(
  deleteDirectoryRoleMappingRequest: DeleteDirectoryRoleMappingRequest,
): string {
  return JSON.stringify(
    DeleteDirectoryRoleMappingRequest$outboundSchema.parse(
      deleteDirectoryRoleMappingRequest,
    ),
  );
}
